import React from 'react';
import { ToastContext, Dropdown } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import RateModel from '../../../../models/rateModel';
import useAppContext from '../../../../context/useAppContext';
import PropTypes from 'prop-types';
import ActionOnRatesModal from './actionOnRatesModal';
import RateTemplate from '../../../../models/rateTemplate';

export function InventoryActionModal({ selectedRates, showModal = false, inventories, onSave, onClose = () => {} }) {
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();

    const mapToInventories = React.useCallback(inventory => ({ key: inventory.pk, text: inventory.name, value: inventory.pk }), []);
    const optionsInventories = React.useMemo(() => {
        if (!inventories) {
            return null;
        }
        let firstOption = [
            {
                key: 'no_inventory',
                text: t('ticket.rates.infos.noInventories'),
                value: 'no_inventory'
            }
        ];

        return firstOption.concat(inventories.map(mapToInventories));
    }, [inventories, mapToInventories]);

    const addRatesToInventory = React.useCallback(
        (inventoryId /*inventoriesTab*/) => {
            setIsSubmitting(true);
            selectedRates.forEach(rate => {
                if (rate instanceof RateModel) {
                    //add key form_id , so that the backend does not delete the linked form
                    rate.form_id = rate.form;
                }
                //For later when a rate will have several inventories
                /*rate.inventories.push(...inventoriesTab);
            rate.inventories = new Set(rate.inventories);
            rate.inventories = Array.from(rate.inventories); */
                rate.inventories = inventoryId !== 'no_inventory' ? [inventoryId] : [];
                rate.translations = { name: {} };
            });
            RateModel.save(
                selectedRates,
                {
                    organizationId: organization.pk,
                    eventId: event.id
                },
                { skip_chart_validation: true }
            )
                .then(() => {
                    toast.success(t(`ticket.rates.updateInventorySuccess`));
                    onSave();
                })
                .catch(e => {
                    toast.error(t(`ticket.rates.updateInventoryError`));
                })
                .finally(() => {
                    setIsSubmitting(false);
                    onClose();
                });
        },
        [selectedRates, organization, event, onSave, onClose]
    );

    if (!selectedRates?.length) return null;

    return (
        <ActionOnRatesModal
            type="inventory"
            selectedId={selectedRates[0].inventories instanceof Array && selectedRates[0].inventories.length > 0 ? selectedRates[0].inventories[0] : null}
            onSave={inventoryId => addRatesToInventory(inventoryId)}
            onClose={() => {
                onClose();
            }}
            options={optionsInventories}
            showModal={showModal}
            title={t(`ticket.rates.addRatesInventory`)}
            isSubmitting={isSubmitting}
            tooltip={t('ticket.rates.inventoryInformation')}
        />
    );
}

InventoryActionModal.propTypes = {
    selectedRates: PropTypes.array.isRequired,
    inventories: PropTypes.array,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func
};

export function InventoryAction({ objects: selectedRates, model = null, inventories, onSave, withModal = true, onClick = () => {} }) {
    const [showModal, setShowModal] = React.useState(false);
    const { t } = useTranslation();

    if (model === RateTemplate) return null;

    return (
        <React.Fragment>
            {withModal && showModal && (
                <InventoryActionModal selectedRates={selectedRates} showModal={showModal} inventories={inventories} onSave={onSave} onClose={() => setShowModal(false)} />
            )}
            <Dropdown.Item
                onClick={() => {
                    onClick();
                    setShowModal(true);
                }}
            >
                {t('ticket.rates.modifyInventory')}
            </Dropdown.Item>
        </React.Fragment>
    );
}

InventoryAction.propTypes = {
    objects: PropTypes.array, //required
    inventories: PropTypes.array.isRequired,
    model: PropTypes.func,
    onSave: PropTypes.func.isRequired
};
